var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { SkeletonContainer, getPaddingMargin } from '../Progress/Skeleton/Skeleton';
const SkeletonContext = createContext({
    loadingContext: false
});
export const CronoSkeleton = (_a) => {
    var { children, display = 'flex', isLoading = false, height = '1rem', width = 'auto', repetition = 1, direction = 'v', margin = '', repetitionMargin = '0.4rem', padding = '' } = _a, props = __rest(_a, ["children", "display", "isLoading", "height", "width", "repetition", "direction", "margin", "repetitionMargin", "padding"]);
    const [isLoadingState, setIsLoadingState] = useState(isLoading);
    useEffect(() => {
        setIsLoadingState(isLoading);
    }, [isLoading]);
    return (_jsx(SkeletonContext.Provider, Object.assign({ value: { loadingContext: isLoadingState } }, { children: _jsx(SkeletonContainer, Object.assign({ direction: direction, height: height, width: width, margin: margin, padding: padding, display: display, repetition: repetition }, { children: [...Array(repetition)].map((_, i) => (_jsx("div", Object.assign({ style: { boxSizing: 'border-box', margin: repetition > 1 ? getPaddingMargin(repetitionMargin) : '0rem' } }, props, { children: children }), i))) })) })));
};
export const useCronoSkeleton = () => useContext(SkeletonContext);
